export const useApiUtils = (dispatch, Actions) => {
  const handleApiError = (error) => {
    let message = 'Ocorreu um erro ao realizar a operação';
    if (error?.response?.data?.fieldErrors?.length) {
      message = `${error.response.data.fieldErrors[0].field}: ${error.response.data.fieldErrors[0].message}`;
    } else if (error?.response?.data?.violations?.length) {
      message = error.response.data.violations[0].message;
    } else if (error?.response?.data?.message) {
      message = error.response.data.message.replace('error.', '').replace('error.', '');
      if (error.response.data.message === 'Forbidden') {
        message = 'Você não possui permissão para acessar esta tela.';
      }
    } else if (error?.message) {
      message = error.message;
    } else {
      console.error('Erro não tratado', error.response, error);
    }

    dispatch(Actions.showMessage({ message, variant: 'error' }));

    return message;
  };

  return { handleApiError };
};
